import React from "react";
import { Button } from "antd";
import styled from "styled-components";

import { fontWeights, sizes } from "../../constant/styles";
import { PRIMARY_50, PRIMARY_100, WHITE, GRAY_300, BLUE_675, BLUE } from "../../constant/colors";
import { useTranslation } from "react-i18next";

const StyledButton = styled(Button)`
  font-size: ${sizes.medium};
  font-weight: ${fontWeights.semibold};
  background: ${(props) => (props.isOwner ? PRIMARY_50 : BLUE_675)};
  color: ${(props) => (props.isOwner ? BLUE : WHITE)};
  border: 1px solid ${(props) => (props.isOwner ? PRIMARY_50 : BLUE_675)};
  border-radius: 6px;
  height: 31px;
  width: 140px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 10px;

  &:hover {
    background: ${(props) => (props.isOwner ? PRIMARY_100 : BLUE_675)};
    color: ${(props) => (props.isOwner ? BLUE : WHITE)};
    border-color: ${(props) => (props.isOwner ? PRIMARY_100 : BLUE_675)};
    opacity: ${(props) => (props.isOwner ? 1 : 0.9)};
  }

  &:focus {
    background: ${(props) => (props.isOwner ? PRIMARY_50 : BLUE)};
    color: ${(props) => (props.isOwner ? BLUE : WHITE)};
    border-color: ${(props) => (props.isOwner ? PRIMARY_50 : BLUE)};
    box-shadow: 0 0 0 4px rgba(47, 84, 155, 0.3) !important;
    outline: none !important;
    opacity: 1 !important;
  }

  &:disabled {
    background: ${GRAY_300};
    color: ${WHITE};
    border-color: ${GRAY_300};
    &:hover {
      background: ${GRAY_300};
      color: ${WHITE};
      border-color: ${GRAY_300};
    }
  }
`;

const SaveNewListButton = ({ setFormPopupsAct, id, disabled, isOwner = false }) => {
  const { t } = useTranslation();

  const handleClick = (e) => {
    e.currentTarget.blur();
    setFormPopupsAct(true, true);
  };

  return (
    <StyledButton onClick={handleClick} id={id} disabled={disabled} isOwner={isOwner}>
      {t("main_view.save_as_new_list")}
    </StyledButton>
  );
};

export default SaveNewListButton;
